import { useCallback, useState } from "react";
import { getGradableModels } from "../../../components/gradableModels/functions";
import { useStableSearch } from "../../hooks/useStableSearch";

const DEFAULT_FILTERS = {
  q: "",
};

export function useGradableModelsSearch(user) {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const runSearch = useCallback(async ({ token, filters: activeFilters, isCurrent }) => {
    setLoading(true);
    setError(null);

    const { q } = activeFilters;
    const data = await getGradableModels(token, undefined, undefined, undefined, undefined, q);

    if (!isCurrent()) {
      return;
    }

    if (data?.type === "error") {
      setError(data);
      setModels([]);
    } else if (data?.type === "success") {
      setModels(data.data ?? []);
    } else {
      setModels(Array.isArray(data) ? data : []);
    }

    setLoading(false);
  }, []);

  const search = useStableSearch(user?.token, filters, runSearch);
  const refresh = useCallback(() => search(), [search]);

  return { models, loading, error, filters, setFilters, search, refresh };
}
